import type {ThreadParticipant, ThreadMessage, Thread} from 'src/features/threads/types';
import {uuid} from 'shared/utils/custom-utils';

export const mockThreadId = uuid();
export const mockUser1Id = uuid();
export const mockUserSelfId = uuid();

export const mockParticipant1: ThreadParticipant = {
    id: uuid(),
    user: {
        id: mockUser1Id,
        name: 'Pavel Klečanský'
    }
};

export const mockParticipantSelf: ThreadParticipant = {
    id: uuid(),
    user: {
        id: mockUserSelfId,
        name: 'Štěpán Drábek'
    }
};

const getPastDate = (options: {daysAgo?: number, hoursAgo?: number, minutesAgo?: number}): Date => {
    const date = new Date();

    if (options.daysAgo) {
        date.setDate(date.getDate() - options.daysAgo);
    }
    if (options.hoursAgo) {
        date.setHours(date.getHours() - options.hoursAgo);
    }
    if (options.minutesAgo) {
        date.setMinutes(date.getMinutes() - options.minutesAgo);
    }

    date.setSeconds(date.getSeconds() - Math.floor(Math.random() * 59));

    if (options.daysAgo || (options.hoursAgo && options.hoursAgo > 1)) {
        date.setSeconds(0);
        date.setMilliseconds(0);
    }

    return date;
};

export const mockThread = {
    id: mockThreadId,
    participants: [mockParticipant1, mockParticipantSelf],
    name: 'Systemisťáci'
};

export const mockThreads: Thread[] = [
    mockThread,
    {
        id: uuid(),
        participants: [mockParticipant1, mockParticipantSelf],
        name: 'Šéfové',
        iconUrl: 'https://www.ostrmuz.cz/__imgthumb/web/2328-4337/2048-2048/cfc9-koruny-web3.jpeg',
        notificationsCount: 2
    }
];

export const mockMessages: ThreadMessage[] = [
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({daysAgo: 1, hoursAgo: 6, minutesAgo: 30}),
        content: 'Dobré ráno! Jaký byl víkend?'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({daysAgo: 1, hoursAgo: 5, minutesAgo: 55}),
        content: 'Ahoj, super! Byl jsem na výletě. A co ty?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({daysAgo: 1, hoursAgo: 5, minutesAgo: 53}),
        content: 'Já spíš odpočíval doma.'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({daysAgo: 1, hoursAgo: 5, minutesAgo: 53}),
        content: 'Potřeboval jsem dobít baterky.'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({daysAgo: 1, hoursAgo: 5, minutesAgo: 52}),
        content: 'Taky jsem koukal na nějaké filmy.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({daysAgo: 1, hoursAgo: 2, minutesAgo: 15}),
        content: 'To zní fajn. Co jsi viděl?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({daysAgo: 1, hoursAgo: 2, minutesAgo: 10}),
        content: 'Nějakou starší sci-fi klasiku.'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 30}),
        content: 'Ahoj, jak se máš dnes?'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 29}),
        content: 'Čau! Mám se fajn, co ty? Něco nového?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 28}),
        content: 'Ale jo, ujde to. Právě jsem dořešil ten bug v API.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 27}),
        content: 'Super! Byl to ten problém s autentizací?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 26}),
        content: 'Přesně ten. Nakonec stačilo jen správně nastavit hlavičky.'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 25}),
        content: 'Mimochodem, viděl jsi tuhle fotku z hor? Nádhera!',
        imageUrl: 'https://images.unsplash.com/photo-1519681393784-d120267933ba?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 24}),
        content: 'Wow, paráda! Kde to je?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 23}),
        content: 'To jsou Alpy, minulý rok.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 22}),
        content: 'Závidím! Já se letos chystám aspoň na Šumavu. Tohle mě navnadilo :)'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 22}),
        imageUrl: 'https://travelking.cdn.it7.sk/images/blog/articles/full-images/ojQHZHKm.jpg'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 21}),
        content: 'Musíme tam někdy vyrazit spolu!'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 4, minutesAgo: 15}),
        content: 'Šumava je taky krásná! Určitě si to užiješ. Společný výlet by byl fajn.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 2, minutesAgo: 30}),
        content: 'Hele, vracím se k práci. Dáme pak někdy kafe a pokecáme víc?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 2, minutesAgo: 29}),
        content: 'Jasně, rád! Co třeba zítra po práci?'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 2, minutesAgo: 28}),
        content: 'Zítra můžu. V kolik končíš?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 2, minutesAgo: 27}),
        content: 'Kolem páté. Můžeme dát sraz v naší oblíbené kavárně?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 2, minutesAgo: 27}),
        content: 'Mají tam teď novou výběrovku z Kolumbie.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 2, minutesAgo: 26}),
        content: 'Perfektní! V pět tam budu.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({hoursAgo: 2, minutesAgo: 25}),
        content: 'Už se těším!'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({hoursAgo: 2, minutesAgo: 20}),
        content: 'Super.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({minutesAgo: 45}),
        content: 'Hele, ještě mě napadlo, jak jsi pokročil s tím novým UI kitem? Mluvil jsi o něm včera.'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({minutesAgo: 44}),
        content: 'Už mám hotové základní komponenty. Chceš se na to podívat?'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({minutesAgo: 43}),
        content: 'Tady je malá ukázka tlačítka.',
        imageUrl: 'https://images04.nicepage.com/feature/481899/button-element.jpg'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({minutesAgo: 42}),
        content: 'A tady input.'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({minutesAgo: 42}),
        imageUrl: 'https://cdn.prod.website-files.com/64e895a2f8733943c6d0ddef/65ae7ad04b52cbfa1ac24991_Input%20Text%20UI%20Element%20-%20uinkits.svg'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({minutesAgo: 41}),
        content: 'Je to zatím WIP, ale základ funguje.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({minutesAgo: 35}),
        content: 'Vypadá to čistě! Líbí se mi ten styl.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({minutesAgo: 34}),
        content: 'Dobrá práce.'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({minutesAgo: 33}),
        content: 'Díky! Zítra u kafe ti můžu ukázat víc detailů.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({minutesAgo: 30}),
        content: 'Domluveno.'
    },
    {
        id: uuid(),
        sender: mockParticipantSelf,
        sentAt: getPastDate({minutesAgo: 5}),
        content: 'Ok, musím běžet na schůzku. Zatím!'
    },
    {
        id: uuid(),
        sender: mockParticipant1,
        sentAt: getPastDate({minutesAgo: 4}),
        content: 'Jasně, zatím ahoj!'
    }
];